<template>
  <div class="ChatHeader">
    <div class="questionBox">
      <div class="play_icon_wrapper">
        <img
          src="@/assets/img/voiceOpen.png"
          v-if="isXFAutoplay"
          @click="setXFAutoplayTopView(false)"
        />
        <img
          src="@/assets/img/voiceClose.png"
          v-else
          @click="setXFAutoplayTopView(true)"
        />
      </div>
      <div class="questionTips" v-if="questionTips !== ''">
        <q
          v-html="questionTips"
          ref="questionTips"
          :class="[/<[^<>]+>/g.test(questionTips) ? 'htmlBox' : '']"
        ></q>
        <span v-if="questionHeight" class="quote">"</span>
      </div>
    </div>
    <div class="topViewWrapper">
      <div class="children" @click="onBlock">

         <img src="../../assets/img/xiaofenggif.gif" alt="" class="childImg"    v-if="AutoplayIng"/>
        <img src="../../assets/img/xiaofeng.png" alt="" class="childImg" v-else />
      </div>
      <div class="loadingBox clear" v-if="chatLoading">
        <img src="../../assets/img/loading1.gif" alt="" class="loadingImg" />
      </div>
      <div class="contentCls" v-else>
        <div class="helloXf">
          <transition enter-active-class="animated bounceInRight">
            <div v-show="isViewFade">
              <!--                            <div class="tipsTodo" v-html="guideTips">-->
              <!--                                {{guideTips?"":pageTips}}-->
              <!--                            </div>-->
              <div class="guideTips" v-html="decodeUnicode(guideTips)">
                <!--                                {{guideTips?guideTips:pageTipsTo}}-->
                <!--                                {{decodeUnicode(guideTips)}}-->
              </div>
            </div>
          </transition>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { RandomNumBoth } from "@/utils/utils";
import { mapState, mapActions, mapMutations } from "vuex";
export default {
  name: "TopView",
  components: {},
  props: {
    durationNum: {
      type: Number,
      default: 0,
    },
    questionTips: {
      type: String,
      default: "",
    },
    guideTips: {
      type: String,
      default: "",
    },
  },
  watch: {
    durationNum(value) {
      // if (value >= 10) {
      //     this.setViewFade(false)
      //     this.setViewFade(true)
      //     this.setTips("不知道说什么？", "戳我试试看...");
      // }
      // if (value < 10) {
      //     this.setViewFade(false)
      //     this.setViewFade(true)
      //     this.setTips("Hello~", "一起来体验吧");
      // }
    },
    questionTips(value) {
      this.$nextTick(() => {
        if (this.$refs.questionTips) {
          let questionHeight = this.$refs.questionTips.offsetHeight;
          this.questionHeight =
            questionHeight >
            parseInt(
              window.getComputedStyle(this.$refs.questionTips).fontSize
            ) *
              1.15 *
              4
              ? true
              : false;
        }
      });
    },
  },
  computed: {
    ...mapState([
      "isViewFade",
      "chatLoading",
      "isXFAutoplay",
      "AutoplayPlayer",
      "AutoplayIng"
    ]),
  },
  data() {
    return {
      isClick: true, ////防止重复点击
      timer: "",
      count: 0,
      pageTips: "",
      pageTipsTo: "",
      isFade: false,
      clickable: false,
      questionHeight: 0,
    };
  },
  methods: {
    ...mapMutations(["setViewFade", "setXFAutoplay", "setAutoplayPlayer","setAutoplayIng"]),
    onAsk() {
      this.$emit("on-ask", "", "");
    },

    setTips(pageTips, pageTipsTo) {
      this.pageTips = pageTips;
      this.pageTipsTo = pageTipsTo;
    },
    onBlock() {
      let that = this;
      if (this.isClick) {
        this.isClick = false;

        this.setViewFade(false);
        // this.setViewFade(true)

        this.onAsk();

        setTimeout(function() {
          that.isClick = true;
        }, 1000);
      }
    },
    // unicode解码 表情
    decodeUnicode(str) {
      if (str) {
        str = str.replace(/\\/g, "%");
        return unescape(str);
      } else {
        return "";
      }
    },
    setXFAutoplayTopView(value) {
      if (value) {
        this.setAutoplayPlayer(document.getElementById("AutoplayRef"));
          this.AutoplayPlayer.addEventListener('ended',()=>{
                              
                              this.setAutoplayIng(false)
                              
                            })
      } else {
        this.AutoplayPlayer.pause();
         this.setAutoplayIng(false)
      }
     
      this.setXFAutoplay(value);
    },
  },
  created() {
    this.setViewFade(true);
    // this.setTips("Hi，我是小封！", "见到你真高兴，您可以试试：");
  },
  mounted() {},
  beforeDestroy() {
    clearInterval(this.timer);
  },
};
</script>
<style lang="less" scoped>
.ChatHeader {
  padding: 0.1rem 0.4rem 0.4rem 0.4rem;
  /*min-height: 3.2rem;*/
  .questionBox {
    min-height: 1.2rem;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: end;
    -ms-flex-align: end;
    align-items: flex-end;
    justify-content: flex-end;
    position: relative;
    .questionTips {
      width: 89%;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 3;
      -webkit-box-orient: vertical;
      word-wrap: break-word;
      max-height:1.44rem;
      overflow: hidden;
      
      /*q{*/
      /*    display: inline-flex;*/
      /*}*/
    }
    .htmlBox {
      display: inline-flex;
    }
    .quote {
      position: absolute;
      bottom: 0;
      right: 0;
    }
    .play_icon_wrapper {
      position: absolute;
      width: 0.48rem;
      height: 0.48rem;
      left: 0.5rem;
      top: 0.4rem;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
  .loadingBox {
    padding-top: 0.4rem;
    margin-left: 0.2rem;

    .loadingImg {
      width: 3.6rem;
      height: 1.7rem;
    }
  }
  .topViewWrapper {
    display: flex;
    justify-content: flex-start;
    align-items: center;

    .pageTips-enter-active {
      transition: all 1s;
    }

    .pageTips-leave-active {
      transition: all 0.2s;
    }

    .pageTips-leave-to {
      opacity: 0;
    }

    .pageTips-enter {
      transform: translateX(30px);
    }

    .children {
      .childImg {
        width: 1.5rem;
        height: 2.2rem;
      }
    }

    .contentCls {
      /*position: relative;*/
      padding-left: 0.4rem;

      .helloXf {
        font-size: 0.5rem;
        color: #fff;

        .tipsTodo {
          font-weight: 600;
          margin: 0.26rem 0;
        }

        .guideTips {
          margin: 0.2rem 0;
          font-size: 0.4rem;
          line-height: 0.62rem;
          /*img{*/
          /*    width: 36px;*/
          /*}*/
          max-height: 3.8rem;
          overflow: hidden;
        }
      }
    }
  }
}
</style>
